import { useState, useMemo, useRef } from 'react'
import moment from 'moment-timezone'
// import html2canvas from 'html2canvas'
import http from 'http'

import PathImage from 'components/PathImage'

import {
  FiMap,
  FiX,
  FiCalendar,
  FiClock,
  FiUsers,
  // FiShare2
} from 'react-icons/fi'

import {
  RiPinDistanceFill
} from 'react-icons/ri'

import {
  PiSpeedometerDuotone
} from 'react-icons/pi'

import {
  GiRollerSkate
} from 'react-icons/gi'

import {
  BiCar
} from 'react-icons/bi'

import {
  MdPedalBike,
  MdOutlineDirectionsBus,
  MdDirectionsWalk
} from 'react-icons/md'

const PathDetail = ( {
  _id: identity,
  close = () => {}
} ) => {
  const [ route, setRoute ] = useState()

  const detailRef = useRef()

  useMemo( () => {
    http( {
      method: 'POST',
      url: '/mongo/findOne',
      data: {
        __model: 'Route',
        __match: {
          _id: identity
        },
        __select: { points: 0 },
        __as: 'route'
      }
    } )
      .then( ( { data } ) => {
        setRoute( data.route )
      } )
  }, [ identity ] )

  // const share = () => {
  //   html2canvas( detailRef.current )
  //     .then( canvas => {
  //       canvas.toBlob( ( blob ) => {
  //         const url = URL.createObjectURL( blob )
  //         console.log( { url } )
  //         // window.Telegram.WebApp.downloadFile( blob, 'image/png', `route-${ moment().unix() }` )
  //         window.Telegram.WebApp.downloadFile( { url, file_name: `route-${ moment().unix }` }, ( a, b ) => {
  //           console.log( { a, b } )
  //         } )
  //       }, 'image/png' )
  //     } )
  // }

  if ( ! route )
    return null

  return <div className="modal full hs">
    <div className="bar">
      <button
      >
        <FiMap />
      </button>


      <h1>route detail</h1>

      { /*
      <button
        onClick={ share }
      >
        <FiShare2 />
      </button>
        */ }

      <button
        onClick={ close }
      >
        <FiX />
      </button>

    </div>

    <div className="one hs air-2x in-air-2x gap-2x bg-secondary" ref={ detailRef }>
      <div className="vs">
        <div className="one vs gap">
          <span><FiCalendar /></span>

          <span className="one">
            {
              moment.tz( route.at * 1000, route.timezone ).format( 'DD MMM, YYYY' )
            }
          </span>
        </div>

        <div className="one vs gap">
          <span className="one ta-right">
            {
              moment.tz( route.at * 1000, route.timezone ).format( 'HH:MM' )
            }
          </span>

          <span><FiClock /></span>
        </div>
      </div>

      <h1 className="size-3x5 ta-center">{ route.name }</h1>

      <div className="vs size-2x8">
        <div className="one vs gap-2x">
          <span><FiUsers /></span>

          <span>{ route.with }</span>
        </div>

        <div className="one vs reverse gap-2x">
          <span>
            {
              route.vehicle === 'skates' ? <GiRollerSkate /> :
              route.vehicle === 'auto' ? <BiCar /> :
              route.vehicle === 'bike' ? <MdPedalBike /> :
              route.vehicle === 'bus' ? <MdOutlineDirectionsBus /> :
              route.vehicle === 'walk' ? <MdDirectionsWalk /> : null
            }
          </span>

          <span>on</span>
        </div>
      </div>

      <div className="vs">
        <div className="one hs gap-2x ai-center">
          <div className="vs gap-2x">
            <span className="one">distance</span>

            <span><RiPinDistanceFill /></span>
          </div>

          <div className="vs gap-2x ai-end">
            <span className="one size-3x5">{ route.distanceKm.toFixed( 2 ) }</span>

            <span>km</span>
          </div>
        </div>

        <div className="one hs gap-2x ai-center">
          <div className="vs gap-2x">
            <span className="one">avg speed</span>

            <span><PiSpeedometerDuotone /></span>
          </div>

          <div className="vs gap-2x ai-end">
            <span className="one size-3x5">{ Math.ceil( route.movingAvgSpeedKmH ) }</span>

            <span>km/h</span>
          </div>
        </div>
      </div>

      <div className="vs">
        <div className="one hs gap-2x ai-center">
          <div className="vs gap-2x">
            <span className="one">max speed</span>

            <span><PiSpeedometerDuotone /></span>
          </div>

          <div className="vs gap-2x ai-end">
            <span className="one size-3x5">{ Math.ceil( route.maxSpeedKmH ) }</span>

            <span>km/h</span>
          </div>
        </div>

        <div className="one hs gap-2x ai-center">
          <div className="vs gap-2x">
            <span className="one">total speed</span>

            <span><PiSpeedometerDuotone /></span>
          </div>

          <div className="vs gap-2x ai-end">
            <span className="one size-3x5">{ Math.ceil( route.totalAvgSpeedKmH ) }</span>

            <span>km/h</span>
          </div>
        </div>
      </div>

      <div className="one vs">
        <PathImage
          identity={ route._id }
        />
      </div>

    </div>
  </div>
}

export default PathDetail
